"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partitionWith = partitionWith;
function partitionWith(values, fns) {
    const out = [];
    for (let i = 0; i < fns.length; i++) {
        out.push([]);
    }
    for (const value of values) {
        for (let i = 0; i < fns.length; i++) {
            if (fns[i](value)) {
                out[i].push(value);
                break;
            }
        }
    }
    return out;
}
